//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'TextArea',
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    showError: {
      type: Boolean,
      default: false
    },
    displayBottom: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: -1
    },
    isCount: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      count: ''
    };
  },

  computed: {
    computedLabel() {
      return !this.displayBottom && this.showError && this.errorMessage ? this.errorMessage : this.label;
    },

    inputClass() {
      return {
        error: this.showError,
        'has-value': this.value,
        'has-label': this.label
      };
    },

    selectValue: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit('input', val);
      }

    }
  },
  methods: {
    formCount(event) {
      if (this.isCount) {
        this.count = "".concat(event.target.value.length, "/").concat(this.maxLength);
      }
    }

  }
};